import React from 'react';
import {AbstractStand} from "./AbstractStand";

export const Stand4 = (props) => <AbstractStand height="20" width="20" type={"4"} {...props}/>;

